<template>
  <div v-if="viewMode == 'module'">
    <v-row>
      <v-col>
        <RecordFilingCreateModal />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <RecordNavigation />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-row>
          <v-col
            cols="12"
            lg="3"
            sm="6"
            md="4"
            v-for="record in allRecordFilings"
            :key="record.id"
          >
            <v-card elevation="3" hover @dblclick="goTo(record.id)">
              <v-card-title>
                {{ record.title }}
                <v-spacer></v-spacer>
                <v-icon>mdi-file-cabinet</v-icon>
              </v-card-title>
              <v-card-subtitle
                >{{ record.name }} - {{ record.description }}</v-card-subtitle
              >
              <v-card-text> Security: {{ record.security_level }} </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn icon>
                  <v-icon @click="editItem(record)">mdi-lead-pencil</v-icon>
                </v-btn>

                <v-btn icon>
                  <v-icon @click="deleteItem(record.id)">mdi-trash-can</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-dialog v-model="dialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.title"
                        label="Title"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.name"
                        label="Name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.description"
                        label="Description"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="editedItem.security_level"
                        :items="security_level_items"
                        label="Security Level"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" v-if="errorMessage">
                      <h3 class="text-center red--text">{{ errorMessage }}</h3>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RecordNavigation from "../RecordNavigation";
import RecordFilingCreateModal from "../RecordFilingCreateModal";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "RecordsViewModule",
  props: {
    viewMode: String,
    search: String
  },
  components: {
    RecordNavigation,
    RecordFilingCreateModal,
  },
  data() {
    return {
      singleSelect: false,
      selected: [],
      errorMessage: null,
      nextPath: "/records/filings/",
      security_level_items: ["Low", "Moderate", "High"],
      dialog: false,
      editedIndex: -1,
      security_level: "",
      editedItem: {
        title: "",
        name: "",
        description: "",
        security_level: "Low",
      },
      defaultItem: {
        title: "",
        name: "",
        security_level: "Low",
      },
    };
  },
  methods: {
    editItem(item) {
      this.errorMessage = null;
      this.editedIndex = this.allRecordFilings.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteRecordFiling(id).then(() => {
            Swal.fire("Deleted!", "Your file has been deleted.", "success");
          });
        }
      });
    },
    goTo(id) {
      location.replace(`/records/filings/${id}`);
    },
    close () {
      this.dialog = false;
      this.errorMessage = null;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    async save () {
      if (this.editedIndex > -1) {
        const update = await this.updateRecordFiling(this.editedItem);
        if(update.error) {
          if(update.status == 400) this.errorMessage = update.message;
          else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Internal Server Error',
            })
          }
        } else if(update) {
          this.showSuccess = true;
          this.name = '';
          this.location = '';
          this.dialog = false;
          this.errorMessage = null;
          this.close()
        }
      } else {
        this.allRecordFilings.push(this.editedItem)
      }
    },
  },
  computed: {
    ...mapGetters(["allRecordFilings"]),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
  },
};
</script>

<style>
</style>